import { useState } from 'react'

export const DEFAULT_AVATAR_URL = process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'

// Переиспользуемый <img> с единой механикой загрузки:
// — ленивая загрузка (loading="lazy", decoding="async") по умолчанию;
// — eager-режим для критичных картинок (fetchpriority="high");
// — fallbackSrc при ошибке загрузки (например, DEFAULT_AVATAR_URL) —
//   вместо ручных onError-свитчеров в каждом компоненте.
export const AppImage = ({
	src,
	alt = '',
	fallbackSrc,
	className,
	eager = false,
	onLoad,
	onError,
	...props
}) => {
	const [failedSrc, setFailedSrc] = useState(null)

	// Картинка не загрузилась и fallback не задан — не показываем сломанную иконку
	if (failedSrc === src && !fallbackSrc) return null

	return (
		<img
			src={failedSrc === src ? fallbackSrc : (src || fallbackSrc)}
			alt={alt}
			loading={eager ? 'eager' : 'lazy'}
			fetchpriority={eager ? 'high' : undefined}
			decoding="async"
			onLoad={onLoad}
			onError={(e) => {
				setFailedSrc((prev) => (prev === src ? prev : src))
				onError?.(e)
			}}
			className={className}
			{...props}
		/>
	)
}
